<app-data-table #dataTable
                [columns]="columns"
                [sortColumn]="sortColumn"
                [direction]="direction"
                [(filters)]="filters"
                [filtersComponent]="dataFilters"
                [showColumnsSelection]="false"
                (onReset)="onReset()"
                [loadPage]="loadPage"
                (onLoad)="onLoad($event)">

    <app-data-filters [fullWidth]="true" [opened]="true" #dataFilters>
        <app-data-filter-group [useAvailableWidth]="true">
            <app-data-filter-date [labelKey]="'webhooks-events.list.filters.triggered-from'"
                                  [model]="triggeredStartDateMoment"
                                  [maxDate]="triggeredEndDateMoment"
                                  [placeholderKey]="'webhooks-events.list.filters.date.placeholder'"
                                  (modelChange)="onTriggeredStartDateChange($event)">
            </app-data-filter-date>

            <app-data-filter-date [labelKey]="'webhooks-events.list.filters.triggered-to'"
                                  [model]="triggeredEndDateMoment"
                                  [minDate]="triggeredStartDateMoment"
                                  [placeholderKey]="'webhooks-events.list.filters.date.placeholder'"
                                  (modelChange)="onTriggeredEndDateChange($event)">
            </app-data-filter-date>

            <app-data-filter-autocomplete [labelKey]="'webhooks-events.list.filters.event-type.label'"
                                          [name]="'eventType'"
                                          [model]="selectedEventTypes"
                                          (modelChange)="onSelectedEventTypesChange($event)"
                                          [options]="allEventTypes"
                                          [placeholderKey]="'webhooks-events.list.filters.event-type.placeholder'"
                                          [notFoundTextKey]="'webhooks-events.list.filters.event-type.notfound'"
                                          [multiple]="true">
            </app-data-filter-autocomplete>

            <app-data-filter-autocomplete [labelKey]="'webhooks-events.list.filters.event-status.label'"
                                          [name]="'eventStatus'"
                                          [model]="selectedEventStatuses"
                                          (modelChange)="onSelectedEventStatusesChange($event)"
                                          [options]="allEventStatuses"
                                          [placeholderKey]="'webhooks-events.list.filters.event-status.placeholder'"
                                          [notFoundTextKey]="'webhooks-events.list.filters.event-status.notfound'"
                                          [multiple]="true">
            </app-data-filter-autocomplete>

            <app-data-filter-input [labelKey]="'webhooks-events.list.filters.delivery.label'"
                                   [placeholderKey]="'webhooks-events.list.filters.delivery.placeholder'"
                                   [(model)]="filters.externalReference">
            </app-data-filter-input>
        </app-data-filter-group>

        <app-data-filters-button [labelKey]="'webhooks-events.list.filters.buttons.bulk-retry'" [type]="'primary'"
                                 (onClick)="openBulkRetrySendingEventsConfirm(bulkRetryModal)">
        </app-data-filters-button>

        <app-data-filters-button [labelKey]="'webhooks-events.list.filters.buttons.select-all'" [type]="'primary'"
                                 (onClick)="selectAll()">
        </app-data-filters-button>
    </app-data-filters>

    <ng-template #dateColumn let-item="item">
        <div class="checkbox">
            <label>
                <input type="checkbox" name="show-device-paths" [class.invisible]="item.status !== 'FAILED'" [(ngModel)]="item.selected">
                <i class="fa checkbox-icon" [class.invisible]="item.status !== 'FAILED'"></i>
                {{ item.triggeredDate | fullDate }}
            </label>
        </div>
    </ng-template>

    <ng-template #deliveryColumn let-externalReference1="externalReference1">
        <a class="cmaweb-link" [href]="link.goToLoadManagementForDelivery(externalReference1)" target="_blank">{{ externalReference1 }}</a>
    </ng-template>

    <ng-template #eventTypeColumn let-eventType="eventType">
        <app-webhook-event-type [type]="eventType"></app-webhook-event-type>
    </ng-template>

    <ng-template #statusColumn let-item="item">
        <app-webhook-event-status [status]="item.status"
                                  [nextTryDate]="item.nextTryDate">
        </app-webhook-event-status>
    </ng-template>

    <ng-template #actionsColumn let-item="item">
        <button class="btn btn-outline-secondary btn-sm" (click)="onEventSelected(item)"><i class="fa fa-eye"></i></button>
    </ng-template>
</app-data-table>


<ng-template #bulkRetryModal let-c="close" let-d="dismiss">
    <span [i18n]="[{target: 'innerHTML', key: 'webhooks-events.list.data.bulk-retry-send.content', params: { count: nbSelectedEvents }}]"></span>
</ng-template>
